import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { loginFailure, loginSuccess } from './authentication.actions';
import { AuthenticationFacade } from './authentication.facade';

@Injectable()
export class AuthenticationEffects {
  constructor(
    private actions$: Actions,
    private authenticationFacade: AuthenticationFacade,
    private router: Router,
  ) {}

  loginSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loginSuccess),
        tap(() => {
          this.router.navigateByUrl(this.authenticationFacade.returnUrl)
            .then(() => {
              this.authenticationFacade.clearReturnUrl();
            });
        }),
      ),
    { dispatch: false },
  );

  loginFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loginFailure),
        tap(() => {
          this.router.navigateByUrl('/401').then();
        }),
      ),
    { dispatch: false },
  );
}
